export enum AdminRole {
  OWNER = 'OWNER',
  SUPER_ADMIN = 'SUPER_ADMIN',
  ADMIN = 'ADMIN',
  ONLY_VIEWER = 'ONLY_VIEWER',
  NO_PERMISSIONS = 'NO_PERMISSIONS'
}